/*
 *
 * OtpErrorToast
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
*/

import { connect } from 'react-redux'
import OtpErrorToast from './OtpErrorToast'
import { nullSafe } from 'Utility/globalMethods'
import { bindActionCreators } from 'redux'
import { doHideToast } from 'Store/actions/toast'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHideToast }, dispatch)
})

const mapStateToProps = (state) => ({
  duration: nullSafe(() => state.toast.toastInfo.duration, 15000)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OtpErrorToast)
